import { Form } from 'antd';
import { RevxRadio } from 'components';
import {
  JobconfigBindingCornerLowerLeftLeftIcon,
  JobconfigBindingCornerLowerLeftRightIcon,
  JobconfigBindingCornerLowerRightLeftIcon,
  JobconfigBindingCornerLowerRightRightIcon,
  JobconfigBindingCornerUpperLeftLeftIcon,
  JobconfigBindingCornerUpperLeftRightIcon,
  JobconfigBindingCornerUpperRightLeftIcon,
  JobconfigBindingCornerUpperRightRightIcon,
} from 'components/Icons';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxRadioProps } from 'components/RevxRadio';
import { BINDING_CORNER_ENUM } from 'domains/jobconfigDomain';
import { useMemo } from 'react';
import { ConfigSvcProps } from '..';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcOption from '../common/CommonJobSvcOption';

const CornerStaple = (props: ConfigSvcProps) => {
  const { id, jobOptionSvc } = props;
  const svcOption = useMemo(() => {
    return {
      corner: jobOptionSvc.options.find((option) => option.label === 'Corner'),
      otherOption: jobOptionSvc.options.filter(
        (option) => option.label !== 'Corner'
      ),
    };
  }, [jobOptionSvc]);
  const bindingCornerRadioProps: RevxRadioProps = {
    outSideRevxLayoutProps: {
      align: 'bottom',
      justify: 'left',
      wrap: 'wrap',
      className: 'jobconfig-jobOption-content-outSideOption',
    },
    inSideRevxLayoutProps: {
      align: 'center',
      className: 'jobconfig-jobOption-content-inSideOption',
    },
    iconSequence: 'last',
    options: [
      {
        value: BINDING_CORNER_ENUM['Upper Left'],
        children: (
          <RevxFlexLayout direction="column">
            <RevxFlexLayout align="bottom">
              <JobconfigBindingCornerUpperLeftLeftIcon
                style={{ width: 80, height: 106, marginRight: 28 }}
              />
              <JobconfigBindingCornerUpperLeftRightIcon
                style={{ width: 106, height: 80 }}
              />
            </RevxFlexLayout>
            <label>Upper Left</label>
          </RevxFlexLayout>
        ),
      },
      {
        value: BINDING_CORNER_ENUM['Lower Left'],
        children: (
          <RevxFlexLayout direction="column">
            <RevxFlexLayout align="bottom">
              <JobconfigBindingCornerLowerLeftLeftIcon
                style={{ width: 80, height: 106, marginRight: 28 }}
              />
              <JobconfigBindingCornerLowerLeftRightIcon
                style={{ width: 106, height: 80 }}
              />
            </RevxFlexLayout>
            <label>Lower Left</label>
          </RevxFlexLayout>
        ),
      },
      {
        value: BINDING_CORNER_ENUM['Upper Right'],
        children: (
          <RevxFlexLayout direction="column">
            <RevxFlexLayout align="bottom">
              <JobconfigBindingCornerUpperRightLeftIcon
                style={{ width: 80, height: 106, marginRight: 28 }}
              />
              <JobconfigBindingCornerUpperRightRightIcon
                style={{ width: 106, height: 80 }}
              />
            </RevxFlexLayout>
            <label>Upper Right</label>
          </RevxFlexLayout>
        ),
      },
      {
        value: BINDING_CORNER_ENUM['Lower Right'],
        children: (
          <RevxFlexLayout direction="column">
            <RevxFlexLayout align="bottom">
              <JobconfigBindingCornerLowerRightLeftIcon
                style={{ width: 80, height: 106, marginRight: 28 }}
              />
              <JobconfigBindingCornerLowerRightRightIcon
                style={{ width: 106, height: 80 }}
              />
            </RevxFlexLayout>
            <label>Lower Right</label>
          </RevxFlexLayout>
        ),
      },
    ].filter((item) => svcOption?.corner?.values.includes(item.value)),
  };
  return (
    <>
      <div className="jobconfig-jobOption-content-title">Corner Staple</div>
      <div className="jobconfig-jobOption-content-subTitle">Binding</div>
      <RevxFlexLayout className="jobconfig-jobOption-content-binding">
        <Form.Item name={[id, 'Corner']}>
          <RevxRadio {...bindingCornerRadioProps} />
        </Form.Item>
        <CommonJobSvcOption
          {...props}
          customerOptions={svcOption?.otherOption}
        />
      </RevxFlexLayout>
      <CommonJobSvcInstructions {...props} />
      <CommonJobSvcMessage {...props} />
      <div className="jobconfig-jobOption-content-border"></div>
    </>
  );
};

export default CornerStaple;
